import React from "react";

const Java_Var = () => {
  return (
    <div>
      <h1>Java Var</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Var in Java.</p>
    </div>
  );
};

export default Java_Var;
